import generateQueryParams from '@/utils/generateQueryParams';
import axiosInstance from '@/plugins/api/axiosInstance';

export default function labelFormat() {
    return {
        index,
        getLabel,
        save
    };

    function index(options = {}) {
        const defaultValues = {
            pattern: '',
            limit: 25,
            page: 1
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`label-format/search${params}`);
    }

    function getLabel(options = {}) {
        const defaultValues = {
            type: 'Receipt',
            id: null
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`label-format/json-label${params}`);
    }

    function save(payload) {
        const url = payload.id ? 'label-format/update' : 'label-format/create';
        const formData = new FormData();

        const cleanElements = payload.elements.map(
            // eslint-disable-next-line no-unused-vars
            ({ _file, ...rest }) => rest
        );
        const jsonPayload = JSON.stringify({
            ...payload,
            elements: cleanElements
        });

        formData.append('data', jsonPayload);

        payload.elements.forEach((element) => {
            if (element._file && element.fileimage) {
                formData.append(`files[]`, element._file, element.fileimage);
            }
        });

        return axiosInstance['post'](url, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    }
}
